/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import MainWidgetContainer from './widgets/MainWidgetContainer/MainWidgetContainer';
import AvailableContainer from './widgets/AvailableContainer/AvailableContainer';
import TradingAccountSelect from './widgets/TradingAccountSelect/TradingAccountSelect';

import PageTitle from 'components/PageTitleLegacy/PageTitle';
import PageWrapper from 'components/PageWrapper/PageWrapper';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from './Dashboard.module.scss';

type InjectedProps = TranslatorProps;

@translate()
@inject('dashboardStore')
@observer
export class Dashboard extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  render() {
    const { t, dashboardStore } = this.props;
    const id = dashboardStore.loadedTradingAccount;
    const accounts: any = dashboardStore.myaccounts ? dashboardStore.myaccounts.data : null;
    const tradingAccount = accounts && accounts.filter(item => item.id === id)[0];
    const label = tradingAccount && `${tradingAccount.name} - ${tradingAccount.account_no}`;
    const title = !tradingAccount ? t('general:dashboard') : `${t('general:dashboard')} - ${label}`;

    return (
      <PageWrapper isFlex={false}>
        <PageTitle title={title} />

        <div className={styles['dashboard-grid']}>
          <div className={styles['d-widget-area--main']}>
            <div className={styles['d-widget-top']}>
              <MainWidgetContainer />
            </div>
          </div>
          <div className={styles['d-widget-area--side']}>
            <TradingAccountSelect />
            <AvailableContainer />
          </div>
        </div>
      </PageWrapper>
    );
  }
}
